package one.healthium.healthKit.data

import kotlinx.datetime.Instant
import kotlin.coroutines.resume
import kotlin.coroutines.suspendCoroutine

// TODO
actual class HealthKitManager() {

    actual suspend fun getHealthKitStatus(): HealthKitStatus {
        return HealthKitStatus.UNKNOWN
    }

    actual suspend fun connectToHealthKit() {
        return suspendCoroutine { continuation ->
            continuation.resume(Unit)
        }
    }

    actual suspend fun logWeight(weight: Float) {

    }

    actual suspend fun logWater(amount: Float) {

    }

    actual suspend fun getSteps(): Long? {
        return suspendCoroutine { continuation ->
            continuation.resume(null)
        }
    }

    actual suspend fun getWeightLogSince(since: Instant): List<HKWeightLogRecord> {
        return suspendCoroutine { continuation ->
            continuation.resume(emptyList())
        }
    }

    actual fun launchHealthApp() {
    }
}
